'use client';

import { setCollectionRegistry } from '@/../../shared/config/monitored-collections';

/**
 * Hydrates the client-side collection→chain registry (shared/config/
 * monitored-collections.js) from the map the root layout loaded server-side,
 * so synchronous getCollectionBlockchain/DisplayName/Currency calls in client
 * components resolve live tracked_collections data instead of the static map.
 *
 * Wraps children (rather than rendering as a sibling) so the registry is set
 * before any descendant client component renders. The call is idempotent and
 * runs during render on purpose — effects would fire AFTER children render.
 */
export default function CollectionRegistryHydrator({
  registry,
  children,
}: {
  registry: Record<string, { blockchain: string; displayName: string }>;
  children: React.ReactNode;
}) {
  setCollectionRegistry(registry);
  return <>{children}</>;
}
